import type {
  ProductUnitName,
  SubscriptionDetails,
} from "schemas/generated/billing";

export const getCountOfProductUnitsInSubscription = ({
  subscription,
  productUnitName,
}: {
  subscription: SubscriptionDetails;
  productUnitName: ProductUnitName;
}) => {
  return subscription.productUnits.filter(
    (unit) => unit.name === productUnitName,
  ).length;
};
